import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  List,
  Avatar,
  ListItem,
  Typography,
  ListItemText,
  ListItemAvatar,
  styled,
} from '@mui/material';
import moment from 'moment';
import Paginator from 'components/Paginator';

// Styled components
const ListBox = styled(Box)({
  height: 'calc(100% - 198px)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const ListRoot = styled(List)(({ theme }) => ({
  height: '100%',
  marginTop: theme.spacing(1.25),
  maxHeight: 300,
  overflow: 'auto',
}));

const AvatarWrapper = styled(ListItemAvatar)({
  marginRight: -19,
});

const StyledAvatar = styled(Avatar)({
  backgroundColor: '#00C1BA',
  height: 28,
  width: 28,
  fontSize: 13,
  marginTop: -4,
  marginRight: 10,
});

const ListItemStyled = styled(ListItem)(({ theme }) => ({
  backgroundColor: '#FBFBFB',
  margin: 0,
  marginBottom: theme.spacing(2),
}));

const Name = styled(Typography)({
  fontSize: 13,
  fontWeight: 'bold',
  lineHeight: 1.23,
  color: '#4D4F5C',
});

const Date = styled(Typography)({
  fontSize: 12,
  color: '#777777',
});

const CommentText = styled(Typography)(({ theme }) => ({
  color: '#4D4F5C',
  fontSize: 13,
  marginTop: theme.spacing(1),
  display: 'block',
  lineHeight: 1.18,
}));

const CommentsList = ({
  params,
  comments,
  pagination,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const { localeFormat } = useSelector((state) => state.organizations);

  return (
    <ListBox>
      <ListRoot>
        {comments?.map((comment, index) => (
          <ListItemStyled key={index} alignItems="flex-start">
            <AvatarWrapper>
              <StyledAvatar alt="User">
                {comment?.entry_user?.first_name?.charAt(0)}
                {comment?.entry_user?.last_name?.charAt(0)}
              </StyledAvatar>
            </AvatarWrapper>
            <ListItemText
              primary={
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Name variant="body2" component="span" color="textPrimary">
                    {comment?.entry_user?.first_name} {comment?.entry_user?.last_name}
                  </Name>
                  <Date variant="body2" component="span" color="textSecondary">
                    {moment(comment.created_time).format(`${localeFormat} - hh:mm a`)}
                  </Date>
                </Box>
              }
              secondary={
                <CommentText component="span" color="textSecondary">
                  {comment?.body}
                </CommentText>
              }
            />
          </ListItemStyled>
        ))}
      </ListRoot>
      <Paginator
        component="div"
        limit={params.limit}
        onPageChange={handleChangePage}
        pagination={pagination}
        labelRowsPerPage="Page size"
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </ListBox>
  );
};

CommentsList.propTypes = {
  params: PropTypes.object,
  comments: PropTypes.array,
  pagination: PropTypes.object,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
};

CommentsList.defaultProps = {
  params: {
    page: 1,
    limit: 10,
  },
  comments: [],
  pagination: {},
  handleChangePage: () => {},
  handleChangeRowsPerPage: () => {},
};

export default CommentsList;
